import { NgModule } from '@angular/core';
import { FormsModule }  from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ErrorRoutingModule } from './error.routing.module';
import { ErrorComponent } from './error.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ErrorRoutingModule,
  ],
  exports: [
    ErrorComponent,
  ],
  declarations: [
    ErrorComponent,
  ],
})
export class ErrorModule {
}
